import { NgModule } from '@angular/core';
import { ValidDomainEmailPipe } from './valid-domain-email.pipe';

@NgModule({
  declarations: [ValidDomainEmailPipe],
  exports: [ValidDomainEmailPipe]
})
export class ValidDomainEmailPipeModule {}
